"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "Autosave", {
  enumerable: !0,
  get: function get() {
    return _Autosave["default"];
  }
}), Object.defineProperty(exports, "NotificationsProvider", {
  enumerable: !0,
  get: function get() {
    return _Notifications.NotificationsProvider;
  }
}), Object.defineProperty(exports, "notify", {
  enumerable: !0,
  get: function get() {
    return _Notifications.notify;
  }
}), Object.defineProperty(exports, "NotFound", {
  enumerable: !0,
  get: function get() {
    return _NotFound["default"];
  }
}), Object.defineProperty(exports, "Error", {
  enumerable: !0,
  get: function get() {
    return _Error["default"];
  }
}), Object.defineProperty(exports, "NoOrganisations", {
  enumerable: !0,
  get: function get() {
    return _NoOrganisations["default"];
  }
}), Object.defineProperty(exports, "RequestProvider", {
  enumerable: !0,
  get: function get() {
    return _RequestProvider["default"];
  }
}), Object.defineProperty(exports, "Form", {
  enumerable: !0,
  get: function get() {
    return _Form["default"];
  }
}), Object.defineProperty(exports, "SocialProfiles", {
  enumerable: !0,
  get: function get() {
    return _SocialProfiles["default"];
  }
}), Object.defineProperty(exports, "BasicUserProfile", {
  enumerable: !0,
  get: function get() {
    return _BasicUserProfile["default"];
  }
}), Object.defineProperty(exports, "ManageAssetModal", {
  enumerable: !0,
  get: function get() {
    return _ManageAssetModal["default"];
  }
}), Object.defineProperty(exports, "ConfirmationModal", {
  enumerable: !0,
  get: function get() {
    return _ConfirmationModal["default"];
  }
}), Object.defineProperty(exports, "DeleteConfirmationModal", {
  enumerable: !0,
  get: function get() {
    return _DeleteConfirmationModal["default"];
  }
}), Object.defineProperty(exports, "UploaderProvider", {
  enumerable: !0,
  get: function get() {
    return _Uploader.UploaderProvider;
  }
}), Object.defineProperty(exports, "UploaderConsumer", {
  enumerable: !0,
  get: function get() {
    return _Uploader.UploaderConsumer;
  }
}), Object.defineProperty(exports, "withAssetSelector", {
  enumerable: !0,
  get: function get() {
    return _Uploader.withAssetSelector;
  }
}), Object.defineProperty(exports, "withAssetsSelector", {
  enumerable: !0,
  get: function get() {
    return _Uploader.withAssetsSelector;
  }
}), Object.defineProperty(exports, "AssetSelector", {
  enumerable: !0,
  get: function get() {
    return _Uploader.AssetSelector;
  }
}), Object.defineProperty(exports, "AssetsSelector", {
  enumerable: !0,
  get: function get() {
    return _Uploader.AssetsSelector;
  }
}), Object.defineProperty(exports, "AssetPreview", {
  enumerable: !0,
  get: function get() {
    return _AssetPreview["default"];
  }
}), Object.defineProperty(exports, "UploadFilesModal", {
  enumerable: !0,
  get: function get() {
    return _UploadFilesModal["default"];
  }
}), Object.defineProperty(exports, "CommentsProvider", {
  enumerable: !0,
  get: function get() {
    return _Comments.CommentsProvider;
  }
}), Object.defineProperty(exports, "CommentsConsumer", {
  enumerable: !0,
  get: function get() {
    return _Comments.CommentsConsumer;
  }
}), Object.defineProperty(exports, "CommentPopover", {
  enumerable: !0,
  get: function get() {
    return _Comments.CommentPopover;
  }
}), Object.defineProperty(exports, "CommentsOverlay", {
  enumerable: !0,
  get: function get() {
    return _Comments.CommentsOverlay;
  }
}), Object.defineProperty(exports, "CommentsTab", {
  enumerable: !0,
  get: function get() {
    return _Comments.CommentsTab;
  }
}), Object.defineProperty(exports, "CommentsList", {
  enumerable: !0,
  get: function get() {
    return _Comments.CommentsList;
  }
}), Object.defineProperty(exports, "RichTextEditor", {
  enumerable: !0,
  get: function get() {
    return _RichTextEditor.RichTextEditor;
  }
}), Object.defineProperty(exports, "getContentState", {
  enumerable: !0,
  get: function get() {
    return _RichTextEditor.getContentState;
  }
}), Object.defineProperty(exports, "convertToEditorState", {
  enumerable: !0,
  get: function get() {
    return _RichTextEditor.convertToEditorState;
  }
}), Object.defineProperty(exports, "HistoryTab", {
  enumerable: !0,
  get: function get() {
    return _HistoryTab["default"];
  }
}), Object.defineProperty(exports, "ContentLoader", {
  enumerable: !0,
  get: function get() {
    return _ContentLoader["default"];
  }
}), Object.defineProperty(exports, "Player", {
  enumerable: !0,
  get: function get() {
    return _Player["default"];
  }
}), Object.defineProperty(exports, "VideoPlaceholder", {
  enumerable: !0,
  get: function get() {
    return _VideoPlaceholder["default"];
  }
}), Object.defineProperty(exports, "NavigationFooter", {
  enumerable: !0,
  get: function get() {
    return _NavigationFooter["default"];
  }
}), Object.defineProperty(exports, "ExploreMore", {
  enumerable: !0,
  get: function get() {
    return _ExploreMore["default"];
  }
}), Object.defineProperty(exports, "DragHandler", {
  enumerable: !0,
  get: function get() {
    return _DragHandler["default"];
  }
}), Object.defineProperty(exports, "requiresPermission", {
  enumerable: !0,
  get: function get() {
    return _requiresPermission.requiresPermission;
  }
}), Object.defineProperty(exports, "hasPermission", {
  enumerable: !0,
  get: function get() {
    return _requiresPermission.hasPermission;
  }
}), Object.defineProperty(exports, "withPublicLink", {
  enumerable: !0,
  get: function get() {
    return _WithPublicLink["default"];
  }
}), Object.defineProperty(exports, "CollaborationProvider", {
  enumerable: !0,
  get: function get() {
    return _CollaborationProvider.CollaborationProvider;
  }
}), Object.defineProperty(exports, "CollaborationConsumer", {
  enumerable: !0,
  get: function get() {
    return _CollaborationProvider.CollaborationConsumer;
  }
}), Object.defineProperty(exports, "CollaborationPageHeader", {
  enumerable: !0,
  get: function get() {
    return _CollaborationPageHeader["default"];
  }
}), Object.defineProperty(exports, "Files", {
  enumerable: !0,
  get: function get() {
    return _Files["default"];
  }
}), Object.defineProperty(exports, "PaymentsInvoice", {
  enumerable: !0,
  get: function get() {
    return _PaymentsInvoice["default"];
  }
}), Object.defineProperty(exports, "REJECTION_REASONS", {
  enumerable: !0,
  get: function get() {
    return _PaymentsInvoice.REJECTION_REASONS;
  }
}), Object.defineProperty(exports, "PostDetailsForm", {
  enumerable: !0,
  get: function get() {
    return _PostDetailsForm["default"];
  }
}), Object.defineProperty(exports, "AuthorisationProvider", {
  enumerable: !0,
  get: function get() {
    return _AuthorisationWrapper.AuthorisationProvider;
  }
}), Object.defineProperty(exports, "AuthorisationConsumer", {
  enumerable: !0,
  get: function get() {
    return _AuthorisationWrapper.AuthorisationConsumer;
  }
}), Object.defineProperty(exports, "AuthenticationProvider", {
  enumerable: !0,
  get: function get() {
    return _AuthenticationWrapper.AuthenticationProvider;
  }
}), Object.defineProperty(exports, "AuthenticationConsumer", {
  enumerable: !0,
  get: function get() {
    return _AuthenticationWrapper.AuthenticationConsumer;
  }
}), Object.defineProperty(exports, "DownloadAssetMenu", {
  enumerable: !0,
  get: function get() {
    return _DownloadAssetMenu.DownloadAssetMenu;
  }
}), Object.defineProperty(exports, "downloadFile", {
  enumerable: !0,
  get: function get() {
    return _DownloadAssetMenu.downloadFile;
  }
}), Object.defineProperty(exports, "BurnInCaptions", {
  enumerable: !0,
  get: function get() {
    return _Addons.BurnInCaptions;
  }
}), Object.defineProperty(exports, "SrtCaptions", {
  enumerable: !0,
  get: function get() {
    return _Addons.SrtCaptions;
  }
}), Object.defineProperty(exports, "Duration", {
  enumerable: !0,
  get: function get() {
    return _Addons.Duration;
  }
}), Object.defineProperty(exports, "RushEdit", {
  enumerable: !0,
  get: function get() {
    return _Addons.RushEdit;
  }
}), Object.defineProperty(exports, "ChromaKey", {
  enumerable: !0,
  get: function get() {
    return _Addons.ChromaKey;
  }
}), Object.defineProperty(exports, "AspectRatio", {
  enumerable: !0,
  get: function get() {
    return _Addons.AspectRatio;
  }
}), Object.defineProperty(exports, "AddonsConsumer", {
  enumerable: !0,
  get: function get() {
    return _Addons.AddonsConsumer;
  }
}), Object.defineProperty(exports, "AddonsProvider", {
  enumerable: !0,
  get: function get() {
    return _Addons.AddonsProvider;
  }
}), Object.defineProperty(exports, "CreditsProvider", {
  enumerable: !0,
  get: function get() {
    return _Credits.CreditsProvider;
  }
}), Object.defineProperty(exports, "CreditsConsumer", {
  enumerable: !0,
  get: function get() {
    return _Credits.CreditsConsumer;
  }
}), Object.defineProperty(exports, "CreditsInfo", {
  enumerable: !0,
  get: function get() {
    return _Credits.CreditsInfo;
  }
}), Object.defineProperty(exports, "CreditsOverview", {
  enumerable: !0,
  get: function get() {
    return _Credits.CreditsOverview;
  }
}), Object.defineProperty(exports, "SubmissionsGraph", {
  enumerable: !0,
  get: function get() {
    return _Credits.SubmissionsGraph;
  }
});

var _Autosave = _interopRequireDefault(require("./components/Autosave")),
    _Notifications = require("./components/Notifications"),
    _NotFound = _interopRequireDefault(require("./components/NotFound")),
    _Error = _interopRequireDefault(require("./components/Error")),
    _NoOrganisations = _interopRequireDefault(require("./components/NoOrganisations")),
    _RequestProvider = _interopRequireDefault(require("./components/RequestProvider")),
    _Form = _interopRequireDefault(require("./components/Form")),
    _SocialProfiles = _interopRequireDefault(require("./components/SocialProfiles")),
    _BasicUserProfile = _interopRequireDefault(require("./components/BasicUserProfile")),
    _ManageAssetModal = _interopRequireDefault(require("./components/ManageAssetModal")),
    _ConfirmationModal = _interopRequireDefault(require("./components/ConfirmationModal")),
    _DeleteConfirmationModal = _interopRequireDefault(require("./components/DeleteConfirmationModal")),
    _Uploader = require("./components/Uploader"),
    _AssetPreview = _interopRequireDefault(require("./components/AssetPreview")),
    _UploadFilesModal = _interopRequireDefault(require("./components/UploadFilesModal")),
    _Comments = require("./components/Comments"),
    _RichTextEditor = require("./components/RichTextEditor"),
    _HistoryTab = _interopRequireDefault(require("./components/HistoryTab")),
    _ContentLoader = _interopRequireDefault(require("./components/ContentLoader")),
    _Player = _interopRequireDefault(require("./components/Player")),
    _VideoPlaceholder = _interopRequireDefault(require("./components/VideoPlaceholder")),
    _NavigationFooter = _interopRequireDefault(require("./components/NavigationFooter")),
    _ExploreMore = _interopRequireDefault(require("./components/ExploreMore")),
    _DragHandler = _interopRequireDefault(require("./components/DragHandler")),
    _requiresPermission = require("./components/requiresPermission"),
    _WithPublicLink = _interopRequireDefault(require("./components/WithPublicLink")),
    _CollaborationProvider = require("./components/CollaborationProvider"),
    _CollaborationPageHeader = _interopRequireDefault(require("./components/CollaborationPageHeader")),
    _Files = _interopRequireDefault(require("./components/Files")),
    _PaymentsInvoice = _interopRequireWildcard(require("./components/PaymentsInvoice")),
    _PostDetailsForm = _interopRequireDefault(require("./components/PostDetailsForm")),
    _AuthorisationWrapper = require("./components/AuthorisationWrapper"),
    _AuthenticationWrapper = require("./components/AuthenticationWrapper"),
    _DownloadAssetMenu = require("./components/DownloadAssetMenu"),
    _Addons = require("./components/Addons"),
    _Credits = require("./components/Credits");